{
  "en": {
    "form": {
      "actions": {
        "cancel": "Cancel",
        "clear": "Clear",
        "closeFullPage": "Close full page",
        "copyText": "Click to copy text",
        "create_and_attach_phase": "Create and attach to phase",
        "create_and_send": "Create and send",
        "create_and_send_to_customer": "Create and send to customer",
        "create_and_share": "Create and share with customer",
        "create_and_share_partners_only": "Create and share with partner(s)",
        "create_and_share_with_partners": "Create and share with customer and partner(s)",
        "next": "Next",
        "only_create": "Only create",
        "openFullPage": "Open in full page",
        "save": "Save",
        "saveChanges": "Save changes",
        "save_as_draft": "Save as draft",
        "search": "Search...",
        "send": "Send",
        "send_and_create_another": "Send and create another",
        "send_to_customer": "Send to customer",
        "share_with_customer": "Share with customer",
        "submit": "Submit",
        "submit_and_create_another": "Submit and create another"
      },
      "back": "Previous step",
      "labels": {
        "columns": "Columns",
        "from": "From",
        "no_results": "No results",
        "optional": "(optional)",
        "to": "To"
      },
      "notifications": {
        "textHasBeenCopied": "Text has been copied"
      },
      "password": "Password",
      "send_moment": {
        "attach_failed": "Created, but not attached to the phase. Attach it again in the workflow.",
        "concept_description": "Nobody sees anything yet. You send it yourself later, or attach it to a phase after all.",
        "concept_title": "Save as draft",
        "item_decision": "this decision",
        "item_survey": "this survey",
        "item_todo": "this task",
        "now_description_decision": "The customers of the selected units get the decision right away, with a notification.",
        "now_description_survey": "The customers of the selected units get the survey right away, with a notification.",
        "now_description_todo": "The assignees of the selected units get the task right away, with a notification.",
        "now_title": "Send now",
        "phase_description": "Goes out per unit as soon as that unit reaches the phase.",
        "phase_label": "Phase",
        "phase_title": "Attach to a phase",
        "summary_concept": "Nothing sent yet",
        "summary_phase": "Goes out when a unit reaches the phase",
        "title": "When does the customer see {item}?",
        "workflow_help": "What is a workflow?",
        "workflow_help_more": "Read more",
        "workflow_help_text": "A workflow is the set of phases every unit goes through. Attach something to a phase and the customer sees it automatically as soon as their unit reaches that phase."
      },
      "shortcuts": {
        "save_mac": "⌘ + Enter to save",
        "save_windows": "Ctrl + Enter to save",
        "send_mac": "⌘ + Enter to send",
        "send_windows": "Ctrl + Enter to send"
      },
      "steps": "Step {count} of {total}",
      "writeEmployeeNameReject": "Write <i><b>{employeeName}</b></i> to continue."
    }
  }
}
